import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';
import { LanguageService } from '../services/language/language.service';

export const languageGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const languageService = inject(LanguageService);

  const lang: string = route.queryParams['lang'];
  if (lang) {
    languageService.setCurrentLanguage(lang);
  }

  return true;
};
